import React from 'react';
import {
  FormField,
  DatePicker,
  Button,
  Select,
} from '@vwfs-bronson/bronson-react';
import './style.css';
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import {
  selectBookings,
  setBookingsDateRageFilter,
  setBookingsPrePaymentState,
  setBookingsStatus
} from "../../../redux/slices/customer-slice";
import { FilterByDateRange } from '../../../redux/slices/types';
import { BookingStatusFilterEnum, PrePaymentStateFilterEnum } from '../../../models/customer-data.interface';
import { BookingPrePaymentState, BookingStatus } from '../booking-history/helper';

export default function BookingHistoryDataFilter() {
  const dispatch = useAppDispatch();
  const bookings = useAppSelector(selectBookings());

  function setDateRange(dateRange: FilterByDateRange) {
    dispatch(setBookingsDateRageFilter(dateRange));
  }

  function setPrePaymentState(paymentState: PrePaymentStateFilterEnum) {
    dispatch(setBookingsPrePaymentState(paymentState));
  }

  function setBookingStatus(bookingStatus: BookingStatusFilterEnum) {
    dispatch(setBookingsStatus(bookingStatus));
  }

  function handleOnDateRangeChange(e) {
    if (e.includes('bis')) {
      const SPLIT_FLAG = ' bis ';
      const dates = e.split(SPLIT_FLAG);
      setDateRange({
        start: dates[0],
        stop: dates[1],
      })
    }
  }

  function handleResetFilters() {
    setDateRange(undefined);
    setBookingStatus('ALL');
    setPrePaymentState('ALL')
  }

  return (
    <div data-testid="bookingsFilter" key="bookingsFilter" className="filter-group">
      <FormField
        labelText="Select Pickup Date Range"
        type="input"
        testId='testSelectDateRange'
      >
        <div style={{ margin: 'auto' }}>
          <DatePicker
            testId='testDatePicker'
            key="bookingsDataRangeSelect"
            mode='range'
            value={bookings.filter?.dateRange ? `${bookings.filter.dateRange.start} bis ${bookings.filter.dateRange.stop}` : undefined}
            onChange={handleOnDateRangeChange}
          />
        </div>
      </FormField>

      <FormField
        labelText="Select Booking Status"
        type="input"
        testId='testSelectBookingStatus'
      >
        <Select onChange={(e) => setBookingStatus(e.target.value as BookingStatusFilterEnum)} value={bookings?.filter?.bookingStatus || 'ALL'}>
          <Select.Item value={'ALL'}>All</Select.Item>
          {Object.keys(BookingStatus).map(key => <Select.Item key={key} value={key}>{BookingStatus[key]}</Select.Item>)}
        </Select>
      </FormField >

      <FormField
        labelText="Select Payment State"
        type="input"
        testId='testSelectPaymentState'
      >
        <Select onChange={(e) => setPrePaymentState(e.target.value as PrePaymentStateFilterEnum)} value={bookings?.filter?.prePaymentState || 'ALL'}>
          <Select.Item value={'ALL'}>All</Select.Item>
          {Object.keys(BookingPrePaymentState).map(key => <Select.Item key={key} value={key}>{BookingPrePaymentState[key]}</Select.Item>)}
        </Select>
      </FormField >

      <FormField
        labelText="Action"
        type="input"
      >
        <Button
          onClick={handleResetFilters}
          key="resetBookingFilters"
          testId='testResetFiltersBtn'
        >
          Reset filters
        </Button>
      </FormField >
    </div >
  );
}
